import { Dialog } from '../../components/Dialog.js'
import { Button } from '../../components/controls.js'
import { useUiStore } from '../../state/ui-store.js'

/** Destructive actions confirm first and say how many cards are affected. */
export function ConfirmDialog() {
  const request = useUiStore((state) => state.confirm)
  const close = useUiStore((state) => state.closeConfirm)
  if (!request) return null

  return (
    <Dialog
      open
      title={request.title}
      onClose={close}
      onSubmit={() => {
        request.onConfirm()
        close()
      }}
      footer={
        <>
          <Button onClick={close}>Cancel</Button>
          <Button variant="danger" type="submit" data-autofocus>
            {request.confirmLabel}
          </Button>
        </>
      }
    >
      <p style={{ marginTop: 0 }}>{request.message}</p>
      {request.consequence ? <p style={{ fontWeight: 600 }}>{request.consequence}</p> : null}
      <p style={{ marginBottom: 0, color: 'var(--muted)' }}>
        {request.undoable ? 'You can undo this afterwards.' : 'This cannot be undone.'}
      </p>
    </Dialog>
  )
}
